<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.SqlFormatter.title') }}</span>
      <span class="fmt-spacer" />
      <el-button size="small" icon="el-icon-s-operation" @click="process">{{ $t("common.action.format") }}</el-button>
      <el-button size="small" icon="el-icon-s-fold" @click="compress">{{ $t("common.action.compress") }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain @click="loadSample">{{ $t("common.action.sample") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="code" type="textarea" :rows="18" :placeholder="$t('tool.SqlFormatter.phInput')"
      class="fmt-textarea" />
    <div class="fmt-status-bar">
      <span v-if="code.trim()" class="fmt-ok"><i class="el-icon-circle-check" /> {{ charCount }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.SqlFormatter.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
function formatSql(sql, compress) {
  if (!sql || !sql.trim()) return ''
  var compounds = ['LEFT JOIN','RIGHT JOIN','INNER JOIN','OUTER JOIN','CROSS JOIN','FULL JOIN','NATURAL JOIN','ORDER BY','GROUP BY','PARTITION BY','UNION ALL','INSERT INTO','DELETE FROM','IS NULL','IS NOT NULL','NOT IN','NOT EXISTS']
  var s = sql.replace(/\s+/g, ' ')
  compounds.forEach(function(c) { s = s.replace(new RegExp(c.replace(/ /g, '\\s+'), 'gi'), function(m) { return m.replace(/\s+/g, '_') }) })

  var tokens = [], re = /'[^']*'|"[^"]*"|`[^`]*`|--[^\n]*|\w+(?:\.\w+)*|[^\s\w]/g, m
  while ((m = re.exec(s)) !== null) tokens.push(m[0])
  if (!tokens.length) return ''

  var kw = new Set(['SELECT','FROM','WHERE','AND','OR','NOT','IN','IS','NULL','TRUE','FALSE','AS','ON','LIKE','BETWEEN','EXISTS','CASE','WHEN','THEN','ELSE','END','JOIN','LEFT','RIGHT','INNER','OUTER','CROSS','FULL','NATURAL','LEFT_JOIN','RIGHT_JOIN','INNER_JOIN','OUTER_JOIN','CROSS_JOIN','FULL_JOIN','NATURAL_JOIN','ORDER','BY','ORDER_BY','GROUP','GROUP_BY','HAVING','LIMIT','OFFSET','INSERT','INTO','INSERT_INTO','VALUES','UPDATE','SET','DELETE','FROM','DELETE_FROM','CREATE','TABLE','ALTER','DROP','UNION','UNION_ALL','ALL','DISTINCT','ASC','DESC','IS_NULL','IS_NOT_NULL','NOT_IN','NOT_EXISTS','OVER','PARTITION','PARTITION_BY','WITH','BEGIN','COMMIT','ROLLBACK'])

  var breaks = {
    SELECT:{lvl:0,next:1,nextLine:true}, FROM:{lvl:0,next:0},
    LEFT_JOIN:{lvl:0,next:0}, RIGHT_JOIN:{lvl:0,next:0}, INNER_JOIN:{lvl:0,next:0},
    OUTER_JOIN:{lvl:0,next:0}, CROSS_JOIN:{lvl:0,next:0}, FULL_JOIN:{lvl:0,next:0}, JOIN:{lvl:0,next:0},
    WHERE:{lvl:0,next:1,nextLine:true}, AND:{lvl:1,next:1}, OR:{lvl:1,next:1},
    ORDER_BY:{lvl:0,next:0}, GROUP_BY:{lvl:0,next:0}, HAVING:{lvl:0,next:0},
    LIMIT:{lvl:0,next:0}, OFFSET:{lvl:0,next:0},
    UNION:{lvl:0,next:0}, UNION_ALL:{lvl:0,next:0},
    WHEN:{lvl:0,next:1,nextLine:true}, ELSE:{lvl:0,next:0}, END:{lvl:0,next:0},
    SET:{lvl:0,next:1,nextLine:true}, VALUES:{lvl:0,next:1,nextLine:true},
    OVER:{lvl:0,next:0}, PARTITION_BY:{lvl:0,next:0}
  }

  if (compress) {
    var kw2 = new Set(['LEFT_JOIN','RIGHT_JOIN','INNER_JOIN','OUTER_JOIN','CROSS_JOIN','FULL_JOIN','NATURAL_JOIN','ORDER_BY','GROUP_BY','PARTITION_BY','UNION_ALL','INSERT_INTO','DELETE_FROM','IS_NULL','IS_NOT_NULL','NOT_IN','NOT_EXISTS'])
    return tokens.map(function(t) { return kw2.has(t.toUpperCase()) ? t.replace(/_/g, ' ') : t }).join(' ')
  }

  var lines = [], INDENT = '  ', line = '', level = 0

  function push() { if (line.trim()) lines.push(line); line = '' }

  tokens.forEach(function(t, i) {
    var upper = t.toUpperCase()
    var isKw = kw.has(upper)
    var display = isKw ? upper.replace(/_/g, ' ') : t

    if (i === 0) {
      if (breaks[upper] !== undefined) {
        var cfg0 = breaks[upper]
        line = INDENT.repeat(cfg0.lvl) + display
        if (cfg0.nextLine) { push(); line = INDENT.repeat(cfg0.next || cfg0.lvl) }
        level = cfg0.next
      } else { line = display }
      return
    }

    if (breaks[upper] !== undefined) {
      var cfg = breaks[upper]
      push()
      line = INDENT.repeat(cfg.lvl) + display
      if (cfg.nextLine) { push(); line = INDENT.repeat(cfg.next || cfg.lvl) }
      level = cfg.next
      return
    }

    if (t === ',') { line += ','; push(); line = INDENT.repeat(level); return }
    if (t === '(') { if (line && line[line.length-1] !== ' ') line += ' '; line += '('; return }
    if (t === ')') { line += ')'; return }
    if (t === ';') { line += ';'; push(); return }

    var ns = line && line[line.length-1] !== ' ' && line[line.length-1] !== '('
    line += (ns ? ' ' : '') + display
  })

  push()
  return lines.join('\n')
}

export default {
  name:'SqlFormatterTool', props:{ config:{ type:Object, default:()=>({}) } },
  data:()=>({ code:'' }),
  computed:{ charCount(){ return this.$t('common.hint.charCount', { n: this.code.length }) } },
  methods:{
    process(){ this.code = formatSql(this.code) },
    compress(){ this.code = formatSql(this.code, true) },
    doCopy(){
      if(!this.code.trim()){ this.$message.warning(this.$t("common.status.noContent"));return }
      navigator.clipboard.writeText(this.code).then(()=>this.$message.success(this.$t("common.status.copied")))
    },
    loadSample(){ this.code = "select u.id,u.name,o.total from users u left join orders o on u.id=o.user_id where u.status=1 and o.created_at>'2024-01-01' order by o.total desc limit 10" },
    clearAll(){ this.code = '' },
    doAction(a){
      if(a==='format')this.process()
      if(a==='copy')this.doCopy()
      if(a==='clear')this.clearAll()
      if(a==='sample')this.loadSample()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 360px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
